export const environment = {
  production: false,
  apiBasePath: "https://dev.payment.cinchhs.com/",
  notifyUrl: "https://apis.dev.accelerate.cinchhs.com/AccelFsmMs/api/servicejobs/estimates/payment",
  payByPhoneUIDomain: "https://dev.paybyphone.cinchhs.com/",
  webContentDomain: 'https://uat.cinchhomeservices.com/',
  loggerMessages: true,
};
